import { Breadcrumb } from "@redotech/redo-web/breadcrumb";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useId,
  useLayoutEffect,
} from "react";

export type DocumentTitleOverriders = Map<
  string,
  (breadcrumb: Breadcrumb[]) => string
>;

export const DocumentTitleOverridersContext = createContext<
  [DocumentTitleOverriders, Dispatch<SetStateAction<DocumentTitleOverriders>>]
>([new Map(), () => {}]);

export function useDocumentTitleOverride(title: string | undefined) {
  const [, setDocumentTitleOverriders] = useContext(
    DocumentTitleOverridersContext,
  );
  const key = useId();

  useLayoutEffect(() => {
    if (!title) {
      return;
    }
    setDocumentTitleOverriders((prev) => new Map(prev).set(key, () => title));
    return () => {
      setDocumentTitleOverriders((prev) => {
        const next = new Map(prev);
        next.delete(key);
        return next;
      });
    };
  }, [key, title, setDocumentTitleOverriders]);
}
